export default "__VITE_ASSET__CVopwdW2__"